"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("core-js/modules/es6.regexp.search");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Router =
/*#__PURE__*/
function () {
  function Router(cb) {
    _classCallCheck(this, Router);

    this.instance = null;
    this.cb = cb;
  }

  _createClass(Router, [{
    key: "listenRouteChange",
    value: function listenRouteChange() {
      history.pushState = this.addHistoryMethod('pushState');
      history.replaceState = this.addHistoryMethod('replaceState');
    }
  }, {
    key: "addHistoryMethod",
    value: function addHistoryMethod(name) {
      var _this = this;

      if (name === 'pushState' || name === 'replaceState') {
        var method = history[name];
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var nextURL = args[args.length - 1];
          var currentURL = "".concat(window.location.pathname).concat(window.location.search); // 判断跳转的 url 是否与当前 url 相同，如相同，可能只是修改 state 或者 next.js 框架在路由初始化时调用了 replaceState
          // 此时不调用任何回调函数

          if (nextURL && nextURL !== currentURL) {
            for (var i = 0; i < _this.cb.length; i++) {
              _this.cb[i]();
            }
          }

          method.apply(history, args);
        };
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance(cb) {
      if (!this.instance) {
        this.instance = new Router(cb);
        this.instance.listenRouteChange();
        return this.instance;
      }

      return this.instance;
    }
  }]);

  return Router;
}();

function invokeCbs(cb) {
  for (var i = 0; i < cb.length; i++) {
    cb[i].apply(this);
  }
}

function _default(cb) {
  // browser router
  Router.getInstance(cb);
  window.addEventListener('popstate', function () {
    invokeCbs.call(this, cb);
  }); //hash router

  window.addEventListener('hashchange', function () {
    invokeCbs.call(this, cb);
  });
}